<template>
  <div class="wrap">
    <button
      class="drop_call hover_op"
      @click="show_drop = !show_drop"
      v-click-outside="hide"
    >
      <img src="@/assets/img/mob_menu_icon.svg" alt="" />
    </button>

    <div class="extras_drop drop" :class="{ active: show_drop }">
      <button
        @click="
          (show_drop = false),
            $store.commit('setRecordRemoveRoom', room_id),
            $store.commit('setRecordRemoveid', id),
            $store.commit('showModal', 'delete_video')
        "
      >
        Remove
      </button>
    </div>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";

export default {
  name: "removeVideoDrop",

  data() {
    return {
      show_drop: false,
    };
  },

  props: {
    id: String,
    room_id: String,
  },

  methods: {
    hide() {
      this.show_drop = false;
    },
  },

  mounted() {
    this.popupItem = this.$el;
  },

  directives: {
    ClickOutside,
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  line-height: 0;
}

.extras_drop {
  z-index: 1;
  width: 322px;
  top: 100%;
  right: 0;
}

.drop_call {
  width: 40px;
  margin-left: 16px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>